export default "__VITE_ASSET__DAjJuEgB__"